<script setup lang="ts">
import { computed } from 'vue';

import type { FileKind } from '@/utils/files';

interface Props {
  fileKind: FileKind;
}

const props = defineProps<Props>();

const primeIconClass = computed(() => {
  switch (props.fileKind) {
    case 'pdf':
      return 'pi-file-pdf';
    case 'image':
      return 'pi-image';
    case 'excel':
      return 'pi-file-excel';
    case 'csv':
      return 'pi-file-excel';
    case 'word':
      return 'pi-file-word';
    case 'powerpoint':
      return 'pi-file';
    case 'text':
      return 'pi-file';
    case 'audio':
      return 'pi-volume-up';
    case 'video':
      return 'pi-video';
    case 'zip':
      return 'pi-folder';
    default:
      return 'pi-file';
  }
});

const colorClass = computed(() => {
  switch (props.fileKind) {
    case 'pdf':
      return 'text-red-600';
    case 'image':
      return 'text-amber-500';
    case 'excel':
      return 'text-emerald-600';
    case 'csv':
      return 'text-gray-600';
    case 'word':
      return 'text-blue-600';
    case 'powerpoint':
      return 'text-orange-600';
    case 'text':
      return 'text-slate-600';
    case 'audio':
      return 'text-indigo-600';
    case 'video':
      return 'text-fuchsia-600';
    case 'zip':
      return 'text-amber-700';
    default:
      return 'text-slate-600';
  }
});
</script>

<template>
  <i :class="['pi', primeIconClass, colorClass]" aria-hidden="true" />
</template>
